import * as React from 'react'
import { SVGProps } from 'react'

function Trophy(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? 32}
      height={props.height ?? 32}
      fill={props.fill ?? 'none'}
      viewBox="0 0 32 32"
      {...props}
    >
      <g
        stroke={props.color ?? '#1D59AF'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M12 28h8M16 23v5M7.25 16H6a4 4 0 0 1-4-4v-2a1 1 0 0 1 1-1h4M24.75 16H26a4 4 0 0 0 4-4v-2a1 1 0 0 0-1-1h-4" />
        <path d="M7 6h18v7.887c0 4.963-3.969 9.075-8.931 9.113A8.998 8.998 0 0 1 7 14V6Z" />
      </g>
      <defs>
        <path fill="#fff" d="M0 0h32v32H0z" />
      </defs>
    </svg>
  )
}
export default Trophy
